export const GET_EXTERNAL_EVIDENCE_START = 'GET_EXTERNAL_EVIDENCE_START';
export const GET_EXTERNAL_EVIDENCE_DONE = 'GET_EXTERNAL_EVIDENCE_DONE';
export const GET_EXTERNAL_EVIDENCE_ERROR = 'GET_EXTERNAL_EVIDENCE_ERROR';

export const GET_UI_CONFIG_START = 'GET_UI_CONFIG_START';
export const GET_UI_CONFIG_DONE = 'GET_UI_CONFIG_DONE';
export const GET_UI_CONFIG_ERROR = 'GET_UI_CONFIG_ERROR';
